// eslint-disable-next-line @nx/enforce-module-boundaries
import { handleFetch } from '@onyx/utils/fetch';

import type { ExternalJWT } from './next-auth';

export const refreshAccessTokenError = 'RefreshTokenError' as const;

// mark the token as expired 10 minutes before it actually expires
// in order to avoid race conditions where the token expires while the user is using the app
// the session is set to refresh the token every 5 minutes
export const refreshBuffer = 10 * 60;

export const refreshToken = async (
  token: ExternalJWT,
  config: {
    client_secret: string;
    client_id: string;
    url: string;
  }
) => {
  if (Date.now() < (token.accessTokenExpiresAt - refreshBuffer) * 1000) {
    return token;
  }

  const body = new URLSearchParams();
  body.append('grant_type', 'refresh_token');
  body.append('client_id', config.client_id);
  body.append('client_secret', config.client_secret);
  body.append('refresh_token', token.refreshToken);
  body.append('response_type', 'code');

  const [error, response] = await handleFetch(config.url, {
    body,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    cache: 'no-store',
  });

  if (error) {
    return {
      ...token,
      error: refreshAccessTokenError,
    };
  }

  const refreshedTokens = (await response?.json()) as {
    access_token: string;
    expires_in: number;
    id_token: string;
    refresh_token?: string;
  };

  return {
    ...token,
    error: undefined,
    idToken: refreshedTokens.id_token,
    accessTokenExpiresAt: Math.floor(
      Date.now() / 1000 + refreshedTokens.expires_in
    ),
    refreshToken: refreshedTokens.refresh_token ?? token.refreshToken,
  };
};
